export default __webpack_public_path__ + "images/6b505d12f69dc290218b467ad4192c52-bg-01.jpg";